import {useEffect, useState} from "react";

const PLAYBACK_RATES = [1, 1.25, 1.5, 2];

export const usePlaybackRate = (audioRef, deps = []) => {
  const [rate, setRate] = useState(1);
  const cycle = () => setRate(current => PLAYBACK_RATES[(PLAYBACK_RATES.indexOf(current) + 1) % PLAYBACK_RATES.length]);

  useEffect(() => {
    if (audioRef.current) audioRef.current.playbackRate = rate;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rate, ...deps]);

  return [rate, cycle];
};
